




























import { Vue, Component } from "vue-property-decorator";
import { currentUserStore } from "@/store/typed";
import store from "../store";
import { User } from "../models";
import ClickOutside from "@/directives/ClickOutside";

@Component({ components: {}, directives: { ClickOutside } })
export default class LanguageTopbarDropdown extends Vue {
  private open = false;

  protected close() {
    this.open = false;
  }

  setLanguage(languageCode: string) {
    // TODO : implement
    this.$i18n.locale  = languageCode.toLowerCase();
  }

  get languages() {
    return ["IT" , "EN" , "FR" , "ES"];
  }

  get options() {
    return this.languages;
  }

  get currentLanguage() {
    // TODO : handle languages
    return this.$i18n.locale.toUpperCase();
  }
}
